<template>
  <div>
    <div @click="dialogVisible=true">
      <slot></slot>
    </div>
    <el-dialog width="340px" title="选择医生" custom-class="take-dialog" :visible.sync="dialogVisible" append-to-body>
      <div class="design-list-warp" v-loading="loading">
        <div class="doctor-list" v-for="item in list" :key="item.id" @click="handleSelect(item)">
          <img v-if="item.head_pic" class="doctor-head" :src="item.head_pic" alt="">
          <div v-else class="doctor-head-default">
            <img src="@/assets/img/base/default.png" alt="">
          </div>
          <div class="doctor-info">
            <div class="doctor-word1">{{ item.real_name }}医生</div>
            <div class="doctor-word2">{{ item.city }}·{{ item.province }}/{{ item.organization }}</div>
          </div>
        </div>
      </div>
<!--      <div class="take-dialog-bottom">-->
<!--        <div class="take-dialog-close" @click="dialogVisible = false">取消</div>-->
<!--        <div class="take-dialog-open" @click="handleConfirm">确定</div>-->
<!--      </div>-->
    </el-dialog>
  </div>
</template>

<script>
import { search } from "@/http/case";
import {GetDoctorList} from "@/http/api";

export default {
  name: "Patient",
  props: {
    doctor_id: {
      type: Number,
      default: null,
    },
    patient_id: {
      type: Number,
      default: null,
    },
  },
  watch: {
    patient_id: {
      handler: function (val, oldVal) {
        if (val != this.select_patient.id) {
          this.select_patient = { id: undefined };
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      login_member_id: undefined,
      searchOption:{
        page: 1,
        pageSize: 99,
        orderBy: ["im_chaosong_at", "desc"],
        mentor_id: "",
        keyWords: "",
        province: ""
      },
      list: [],
      select_patient: { id: undefined },
      loading: false,
    };
  },
  mounted() {
    var member = JSON.parse(localStorage.getItem("member"));
    this.login_member_id = member.id;
    this.$nextTick(() => {
      this.getList();
    });
  },
  methods: {
    openDialog(){
      this.dialogVisible = true
    },
    getList() {
      this.loading = true;
      this.searchOption.mentor_id = JSON.parse(localStorage.getItem('member')).id
      GetDoctorList('/api/member/doctorListMy',this.searchOption).then(res=>{
        this.list = res.data.data;
        this.loading = false;
      })
    },
    handleSelect(item) {
      this.select_patient = item;
      this.handleConfirm()
    },
    handleConfirm() {
      this.emitSelect(this.select_patient);
      this.dialogVisible = false;
    },
    emitSelect(val) {
      this.$emit("update:patient_id", val.id);
      this.$emit("doctor", val);
    },
  },
};
</script>

<style scoped>
.design-list-warp {
  overflow-y: auto;
  max-height: 400px;
}
.doctor-list{
  margin-bottom: 10px;
  height: 78px;
  border-radius: 8px;
  border: 1px solid #E8E8E9;
  padding: 15px 0 15px 15px;
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.doctor-head{
  width: 48px;
  height: 48px;
  margin-right: 10px;
  object-fit: cover;
  border-radius: 50%;
  flex-shrink: 0;
}
.doctor-head-default{
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-right: 10px;
  background: #F4F4F4;
}
.doctor-head-default img{
  width: 15px;
  height: 15px;
  filter: brightness(1.5);
}
.doctor-info{
  width: 507px;
}
.doctor-word1{
  font-size: 17px;
  font-weight: 500;
  color: #000000;
  line-height: 22px;
}
.doctor-word2{
  font-size: 14px;
  margin-top: 4px;
  color: #8F8F8F;
  line-height: 22px;
  white-space: nowrap;
}

</style>
